import React, { useState } from 'react';
import {
  View,
  Text,
  StyleSheet,
  SafeAreaView,
  TouchableOpacity,
  Image,
  FlatList,
} from 'react-native';
import { ms, s, vs } from '../../utils/responsive';
import { NavigationProp } from '@react-navigation/native';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';

interface ProfilePictureSelectScreenProps {
  navigation: NavigationProp<any>;
}

const ProfilePictureSelectScreen = ({ navigation }: ProfilePictureSelectScreenProps) => {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);

  // Mock data for the grid of photos
  const photos = Array.from({ length: 8 }, (_, index) => ({
    id: index,
    uri: 'https://via.placeholder.com/150',
  }));

  const handleSetProfilePicture = () => {
    if (selectedImage !== null) {
      // Handle setting the profile picture
      navigation.goBack();
    }
  };

  const renderPhoto = ({ item }: { item: { id: number; uri: string } }) => (
    <TouchableOpacity
      style={[
        styles.photoItem,
        selectedImage === item.id && styles.selectedPhotoItem,
      ]}
      onPress={() => setSelectedImage(item.id)}
    >
      <Image source={{ uri: item.uri }} style={styles.photo} />
      {selectedImage === item.id && (
        <View style={styles.selectedOverlay}>
          <Icon name="check-circle" size={24} color="#29BFC0" />
        </View>
      )}
    </TouchableOpacity>
  );

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.header}>
        <TouchableOpacity onPress={() => navigation.goBack()}>
          <Icon name="close" size={24} color="#333" />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>Update New Profile Picture</Text>
        <TouchableOpacity
          onPress={handleSetProfilePicture}
          disabled={selectedImage === null}
        >
          <Text
            style={[
              styles.setButton,
              { opacity: selectedImage !== null ? 1 : 0.5 },
            ]}
          >
            Set
          </Text>
        </TouchableOpacity>
      </View>

      <Text style={styles.subtitle}>
        Here are the recent photos to look, start choosing one of them
      </Text>

      <FlatList
        data={photos}
        renderItem={renderPhoto}
        keyExtractor={(item) => item.id.toString()}
        numColumns={2}
        contentContainerStyle={styles.photoGrid}
      />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: ms(20),
    paddingVertical: ms(15),
    borderBottomWidth: ms(1),
    borderBottomColor: '#F0F0F0',
  },
  headerTitle: {
    fontSize: ms(18, 0.3),
    fontWeight: 'bold',
    color: '#333',
  },
  setButton: {
    fontSize: ms(16, 0.3),
    color: '#29BFC0',
    fontWeight: 'bold',
  },
  subtitle: {
    fontSize: ms(16, 0.3),
    color: '#666',
    textAlign: 'center',
    marginVertical: ms(20),
    paddingHorizontal: ms(40),
  },
  photoGrid: {
    padding: ms(10),
  },
  photoItem: {
    flex: 1,
    margin: ms(5),
    borderRadius: ms(10),
    overflow: 'hidden',
    aspectRatio: 1,
  },
  selectedPhotoItem: {
    borderWidth: ms(2),
    borderColor: '#29BFC0',
  },
  photo: {
    width: '100%',
    height: '100%',
  },
  selectedOverlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(0, 196, 204, 0.3)',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default ProfilePictureSelectScreen; 